import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import FloatingButtons from '../ui/FloatingButtons';
import MobileBottomCTA from '../ui/MobileBottomCTA';
import CookieBanner from '../ui/CookieBanner';
import DemoBanner from '../ui/DemoBanner';

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-cream-50 dark:bg-gray-900">
      {/* Skip link for accessibility */}
      <a href="#main-content" className="skip-link">
        Zum Hauptinhalt springen
      </a>

      <DemoBanner />
      <Header />
      <main id="main-content" className="flex-1 pb-[72px] md:pb-0" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      {/* Floating buttons - hidden on mobile where we show MobileBottomCTA */}
      <div className="hidden md:block">
        <FloatingButtons />
      </div>
      {/* Mobile bottom CTA bar */}
      <MobileBottomCTA />
      <CookieBanner />
    </div>
  );
}
